<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('contact_us')" />
        <app-table
                :options="options"
                id="contact-us-table"
        />
    </div>
</template>

<script>
    import ContactUsMixin from "./Mixins/ContactUsMixin";

    export default {
        name: "ContactUs",
        mixins: [ContactUsMixin],
    }
</script>